import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { UserService } from '../services/user.service';
import { TableUtil } from '../admintrademaster/tableUtil';
import { AddEditCustomers } from '../addeditcustomer/addeditcustomer.component';
import { NotificationsService } from 'angular2-notifications';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { WalletsService } from '../services/wallets.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
// import * as moment from 'moment-timezone';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-customerlist',
    templateUrl: './customerlist.component.html',
    styleUrls: ['./customerlist.component.css']
})
export class CustomerListComponent implements OnInit {
    displayedColumns = [
        'name',
        'short_name',
        'email',
        'hyperverge_status',
        'kycstatus',
        'tfa_status',
        'referal_code',
        'withdraw_status',
        'transfer_to_exchange',
        'fiat_transfer_auto_approve',
        'crypto_withdraw_auto_process',
        'country',
        'status',
        '_id',
        'phone',
        'group',
        'ask_price_spread',
        'bid_price_spread',
        'referal_ask_price_spread',
        'referal_bid_price_spread',
        'verification_link',
        'disable',
        'allow_maintenance',
        'createdAt',
        'action'
    ];
    public dataSource = new MatTableDataSource();
    pageSize = 25;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    fromDate;
    toDate;
    filter: any = {};
    // csrf: any;
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    filteredCustomerList = []
    status: string = 'Active';
    constructor(
        private userService: UserService,
        private dialog: MatDialog,
        private notifSer: NotificationsService,
        private changeDetectorRef: ChangeDetectorRef,
        private walletsService: WalletsService,
        private spinnerService: Ng4LoadingSpinnerService) { }

    ngOnInit() {
        this.filteredData();
        this.dataSource.filter = 'Active';
        this.filteredCustomerList = this.dataSource.filteredData;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    copyVerificationLink(link: string): void {
        const textField = document.createElement('textarea');
        textField.innerText = link;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        this.showSnackBar('Link copied to clipboard');
    }

    showSnackBar(message: string): void {
        alert(message);
    }
    async filteredData() {
        this.userService.csrf().subscribe(async success => {
            this.filter["_csrf"] = success._csrf;
            if (!this.filter['status']) {
                this.filter['status'] = 'Active';
            }
            await this.userService.getCustomerList(this.filter).subscribe(async data => {
                const cusRes = data.customers.map(customer => {
                    customer.createdAt = moment(customer.createdAt).format('MM/DD/YY hh:mm:ss A')
                    return customer;
                })
                this.dataSource = new MatTableDataSource(cusRes);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            })
        })
    }
    handleFilterChange(event: Event): void {
        const selectedValue = (event.target as HTMLSelectElement).value;

        this.filter = { status: selectedValue }
        this.filteredData();
    }

    applyFilterDate() {
        this.filteredData();
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const customers = await this.dataSource.filteredData.map((x: any) => ({
                LegalName: x.name,
                ShortName: x.short_name,
                Email: x.email,
                Phone: x.phone,
                Group: x.group,
                KYCStatus: x.kycstatus,
                TFAStatus: x.tfa_status,
                Status: x.status,
                ReferralCode: x.referal_code,
                _id: x._id,
                createdAt: x.createdAt

            }));
            TableUtil.exportArrayToExcel(customers, "customers");
        }

    }
    addEditCustomers(element) {
        let new_element = {}
        if (element) {
            new_element = {
                'name': element.name,
                'short_name': element.short_name,
                'email': element.email,
                'phone': element.phone,
                'phonecode': element.phonecode,
                'referal_code': element.reference_code,
                '_id': element._id
            };
        } else {
            new_element = {
                'name': '',
                'short_name': '',
                'email': '',
                'phone': '',
                'referal_code': '',
                'password': '',
                'passwordrepeat': '',
                '_id': ''
            };
        }
        const dialogRef = this.dialog.open(AddEditCustomers, {
            width: '600px',
            data: new_element,
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                this.filteredData();
            }
        });
    }
    // Convert "Active" or "Deactive" to boolean values
    convertStatusToBoolean(status: string): boolean {
        return status === 'Active';
    }

    // Convert boolean values to "Active" or "Deactive"
    convertBooleanToStatus(value: boolean): string {
        return value ? 'Active' : 'Deactive';
    }
    statusChange(value, element) {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: 'Are you sure want to confirm?',
                buttonText: {
                    ok: 'Yes',
                    cancel: 'Cancel'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                element.status = (value == true) ? 'Active' : 'Deactive';
                this.userService.csrf().subscribe(user => {
                    element['_csrf'] = user._csrf;
                    this.userService.setActiveLatest(element).subscribe(done => {
                        // Manually update the form control value
                        element.status = this.convertBooleanToStatus(value);
                        // Trigger change detection to update the view
                        this.changeDetectorRef.detectChanges();

                        this.notifSer.success(
                            'Success',
                            done.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    }, (err) => {
                        // this.spinnerService.hide();
                        this.notifSer.error(
                            'Error',
                            err.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    })
                })
            }
        });
    }
    // withdrawActivate(event: any, element: any) {
    //     element.withdraw_status = event
    //     this.dialog.open(ConfirmationDialogComponent, {
    //         data: {
    //             message: 'Are you sure want to confirm?',
    //             buttonText: {
    //                 ok: 'Yes',
    //                 cancel: 'Cancel'
    //             }
    //         }
    //     }).afterClosed().subscribe((confirmed: boolean) => {
    //         if (confirmed) {
    //             const { notif } = defaults;
    //             this.userService.csrf().subscribe(user => {
    //                 element['_csrf'] = user._csrf;
    //                 this.userService.updateCustomerWithdrawStatus(element).subscribe((response) => {
    //                     this.notifSer.success(
    //                         'Success',
    //                         response.message, notif
    //                     )
    //                 }, (err) => {
    //                     this.notifSer.error(
    //                         'Error',
    //                         err.message, notif
    //                     )
    //                 })
    //             });
    //         }
    //     });
    // }
    deleteCustomer(userId: string) {
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  delete customer?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notif } = defaults;
                    this.userService.customerDelete(userId).subscribe(done => {
                        // this.csrf();
                        this.spinnerService.hide();
                        this.notifSer.success(
                            'Success',
                            'Customer has been deleted', notif
                        )
                    }, (err) => {
                        this.spinnerService.hide();
                        this.notifSer.error(
                            'Error',
                            err.message, notif
                        )
                    })
                    this.filteredData();
                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    updateCustomer(event: any, element: any, key: any) {
        element[key] = event;
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: 'Are you sure want to confirm?',
                buttonText: {
                    ok: 'Yes',
                    cancel: 'Cancel'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const { notif } = defaults;
                this.userService.csrf().subscribe(user => {
                    var formObj = {};
                    formObj['_id'] = element._id;
                    formObj['_csrf'] = user._csrf;
                    formObj['key'] = key;
                    formObj['value'] = event;
                    this.userService.updateCustomer(formObj).subscribe((response) => {
                        this.notifSer.success(
                            'Success',
                            response.message, notif
                        )
                    }, (err) => {
                        element[key] = !event
                        this.notifSer.error(
                            'Error',
                            err.message, notif
                        )
                    })
                });
            } else {
                element[key] = !event
            }
        });
    }
}





// WEBPACK FOOTER //
// ./src/app/customerlist/customerlist.component.ts